import React from 'react';
import withStyles from 'isomorphic-style-loader/withStyles';
import Grid from '@material-ui/core/Grid';
import Container from '@material-ui/core/Container';
import Button from '@material-ui/core/Button';
import s from './PRO.css';
import Plan from '../../components/Plan/Plan';
import Feature from '../../components/Feature/Feature';
import getUser from '../../utils/getUser';
import HeadMessage from '../../components/Common/HeadMessage/HeadMessage';

class PRO extends React.Component {
	static pay(productId) {
		const { Paddle } = window;
		const user = getUser();

		if (user) {
			Paddle.Checkout.open({
				product: productId,
				email: user.email,
				coupon: 'JULY50',
				passthrough: JSON.stringify({ userId: user ? user.id : '' }),
				successCallback: data => {
					console.log(data); // eslint-disable-line no-console
				},
			});
		} else {
			const loginWindow = window.open(
				'/login/google/close',
				'example',
				'width=500,height=600',
			);

			const timer = setInterval(function() {
				if (!loginWindow) {
					return;
				}

				if (loginWindow.closed) {
					clearInterval(timer);
					document.location.replace(`/pro?pay=${productId}`);
				}
			}, 100);
		}
	}

	componentDidMount() {
		const url = new URL(document.location.href);
		const productId = url.searchParams.get('pay');
		const user = getUser();

		if (!productId || !user) {
			return;
		}

		if (window.Paddle) {
			PRO.pay(productId);
		} else {
			const timer = setInterval(function() {
				if (window.Paddle) {
					clearInterval(timer);
					PRO.pay(productId);
				}
			}, 50);
		}
	}

	render() {
		const user = getUser();

		return (
			<div>
				<HeadMessage>
					<h1>
						<span>PRO</span> version
					</h1>
				</HeadMessage>

				<Container maxWidth="md" style={{ textAlign: 'center' }}>
					<Grid container spacing={8}>
						<Grid item xs={12} md={6}>
							<Feature right>Unlimited widgets</Feature>
							<Feature right>Unlimited habit trackers</Feature>
							<Feature right>2-5 workspaces</Feature>
							<Feature right>
								Daily, weekly, 2 weekly countdown repeat
							</Feature>
						</Grid>

						<Grid item xs={12} md={6}>
							<Feature>Workday countdown</Feature>
							<Feature>Analog clock timezones support</Feature>
							<Feature>Premium support</Feature>
						</Grid>
					</Grid>

					<br />

					<Grid container>
						<Grid item xs={12} md={2} />

						{/* <Grid item xs={12} md={3}>
                            <Plan
                                onClick={() => { PRO.pay(578775) }}
                                header={'Monthly'}
                                price={'$4.99 / month'}
                                style={{ border: '2px solid transparent' }}
                                buttonText={user ? 'Buy now' : 'Login & Buy'}
                                tooltip={user ? '' : 'Login via Google Account'}
                           />
                        </Grid> */}

						<Grid item xs={12} md={4}>
							<Plan
								onClick={() => {
									PRO.pay(578777);
								}}
								header={
									<span>
										Yearly{' '}
										<span className={s.badge}>
											Save 33%
										</span>
									</span>
								}
								price="$39.96 / year"
								style={{ border: '2px solid #5368F0' }}
								buttonText={user ? 'Buy now' : 'Buy now'}
								tooltip={user ? '' : 'Login via Google Account'}
							/>
						</Grid>

						<Grid item xs={12} md={4}>
							<Plan
								onClick={() => {
									PRO.pay(625317);
								}}
								header={
									<span>
										Lifetime{' '}
										<span className={s.badge}>
											Save 90%
										</span>
									</span>
								}
								price="$59 one-time"
								style={{ border: '2px solid transparent' }}
								buttonText={user ? 'Buy now' : 'Buy now'}
								tooltip={user ? '' : 'Login via Google Account'}
							/>
						</Grid>
					</Grid>

					<div className={s.space} />

					<h5>30 days money-back guarantee. No strings attached.</h5>

					<Button
						onClick={() => {
							PRO.pay(578775);
						}}
						color="primary"
					>
						or buy Monthly (4.99$ / month)
					</Button>
					{/* <Button href={'/invite'} color={'primary'}>Invite friends & get up to 20&nbsp;<strong>free widgets</strong></Button> */}
				</Container>
			</div>
		);
	}
}

export default withStyles(s)(PRO);
